import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css';
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'fa',
    },
    theme: {
        themes: {
            light: {
                'q-secondary': '#005851',
                'q-primary': '#46C3B2',
                'brand-700': '#003531',
                'brand-100': '#CCFBEF',
                error: '#B42318',
                success: '#17B26A',
                warning: '#F79009',
                info: '#0083EA'
            }
        }
    }
});
